<template>
  <v-card :class="borderless ? '' : 'px-2 pb-0'" :flat="borderless">
    <v-form ref="form" :lazy-validation="true">
      <v-card-title v-if="title.length" class="px-0 pt-0">{{ title }}</v-card-title>
      <v-row no-gutters>
        <v-col cols="12" class>
          <v-textarea outlined rows="3"
           data-cy="textarea-address"
           v-if="showTextArea"
            label="Adress"
            v-model="localAddress.address1"
            @input="update('address1', $event)"
          />
          <v-text-field
            v-else
            label="Adress"
            data-cy="address1"
            v-model="localAddress.address1"
            outlined
            @input="update('address1', $event)"
          />
          
        </v-col>
      </v-row>
      <v-row class v-if="show">
        <v-col cols="12" class>
          <v-text-field
            label
            outlined
            data-cy="address2"
            v-model="localAddress.address2"
            @input="update('address2', $event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="4" class="pr-2">
          <v-text-field
            label="Postnummer"
            outlined
            data-cy="zip"
            v-model="localAddress.zip"
            @input="update('zip', $event)"
            :rules="[rules.integer, rules.hasLength(5,localAddress.zip)]"
          />
        </v-col>
        <v-col cols="8" class>
          <v-text-field
            label="Ort"
            outlined
            data-cy="city"
            v-model="localAddress.city"
            @input="update('city', $event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-3">
        <v-col cols="12">
          <v-select
            data-cy="select-country"
            v-if="hasCountry"
            label="Land"
            outlined
            :items="countries"
            item-value="key"
            item-text="value"
            v-model="localAddress.country"
            @change="update('country', $event)"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import orderBy from 'lodash/orderBy'
import {RulesMixin} from '@/components/mixins'

// @group Common
export default {
  name: 'AddressBox',

  mixins: [RulesMixin],

  props: {
    // The name of the form
    title: {
      type: String,
      // empty string
      default: ''
    },
    // Address object
    address: {
      type: Object,
      required: true
    },
    // Show Country selector
    hasCountry: {
      type: Boolean,
      // false
      default: false
    },
    // Show field 
    show: {
      type: Boolean,
      // false
      default: true
    },
    // Show field 
    showTextArea: {
      type: Boolean,
      // false
      default: false
    },
    // Have borderless layout
    borderless: {
      type: Boolean,
      // false
      default: false
    },
  },

  data: () => ({
    countries: [],
    localAddress: {
      address1: '',
      address2: '',
      zip: '',
      city: '',
      country: 'SE'
    }
  }),

  methods: {
    // @vuese
    // Method to update localAddress kv pair
    update(key, value) {
      this.localAddress[key]= value
    }
  },

  watch: {
    localAddress: {
      handler: function() {
        // Fire when the address is changed
        // @arg The argument is the changed address
        this.$emit('changed',this.localAddress)
      },
      deep: true
    },
    address() {
      this.localAddress = this.address
    }

  },

  created () {
    this.localAddress = this.address

    const countries = require("i18n-iso-countries")
    countries.registerLocale(require("i18n-iso-countries/langs/sv.json"))
    const countryNames = countries.getNames('sv')
    for (const [key, value] of Object.entries(countryNames)) {
      this.countries.push({key: key, value: value})
    }
    this.countries = orderBy(this.countries, ['value'],['asc'])
  }
}
</script>

<style scoped>
</style>